var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dialog)?_c('div',{staticClass:"absolute top-0 w-full h-screen flex flex-col bg-black bg-opacity-40 z-[99] items-center justify-center"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }